module.exports = __webpack_public_path__ + "assets/image.9da88134.svg";